export { default } from './MultilineTextItem';
